import { ColumnModel, FilterModel } from '../../filter';

export const WorkspaceFilterKey = 'WORKSPACE_FILTER';
export const WorkspaceOrderKey = 'WORKSPACE_ORDER';
export const WorkspaceFilterColumns = [
  'owner',
  'type',
  'subscriptionTierId',
  'assetsCount',
  'routinesCount',
  'alerts',
  'peopleCount',
  'activitiesCount',
  'groupsCount',
  'createdAt',
  'lastScanned',
  'updatedAt',
  'lastActivity',
];
export class WorkspaceFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  columns?: string[];
  subscriptionTiers?: string[];
  types?: string[];

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.columns = data?.columns || WorkspaceFilterColumns;
    this.subscriptionTiers = data?.subscriptionTiers;
    this.types = data?.types;
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    if (this.columns && this.columns.length > 0) {
      filter.columns = this.columns;
    }

    if (this.subscriptionTiers && this.subscriptionTiers.length > 0) {
      filter.subscriptionTiers = this.subscriptionTiers;
    }

    if (this.types && this.types.length > 0) {
      filter.types = this.types;
    }

    return filter;
  }
}
